
      <div class="team-container" [style]="styleExpression"z
           id="{{participant?.participant_id}}"
           [ngClass]="{'incomplete': participant?.incomplete}" >
        <div class="flex_block align-items-center txt-right" >
          <img [src]="participant?.original.avatar" alt="team_image"/>
          <div class="info"[style]="styleExpressionFont">
            <h1>{{participant?.original.participant_name|truncate :participant.truncate}}</h1>
          </div>
        </div>
      </div>
